import React from "react";
import { Row, Col, Card, CardBody, Spinner, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permissions.constants";
// import BatchRecordsTable from "./BatchRecordsTable";

const ConfigView = (props) => {
    const { config, configId, fetchData, viewOnly } = props;
    const foundConfig = config.response && config.response.data && config.response.data.length && !config.loading;
    const configObj = config.response && config.response.data && config.response.data.length ? config.response.data[0] : {};
    return (
        <Row>
           
            <Col>
                <Card className="py-0">
                    <CardBody className={`${viewOnly ? "p-0" : ""}`}>
                        {foundConfig ? (
                            <div className="project-summary">
                                {!viewOnly && (
                                    <AccessControl allowedPermissions={[permissionsConstants.UPDATE_ISSUER_CONFIGURATION]} renderNoAccess={() => null}>
                                        <Link to={`/issuers/config/edit/${configObj.issuerCode}/${configId}`} id="edit-issuer-configs" className="btn btn-sm btn-outline-secondary project-summary__btn">
                                            Edit
                                        </Link>
                                    </AccessControl>
                                )}
                                {configObj && (
                                    <Row className="my-2">
                                        <Col sm="6">
                                            <h5 className="font-weight-bold">Configuration details</h5>
                                            <hr className="my-3" />
                                            <dl className="row">
                                                <dt className="col-sm-5">Configuration Name</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.name || "---"}</p>
                                                </dd>

                                                <dt className="col-sm-5">Configuration Description</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.description || "---"}</p>
                                                </dd>

                                                <dt className="col-sm-5">Currency Code</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.currencyCode || "---"}</p>
                                                </dd>

                                                {/* <dt className="col-sm-5">Request Type</dt>
                        <dd className="col-sm-7">
                          <p>{configObj.requestType || "---"}</p>
                        </dd> */}

                                                <dt className="col-sm-5">Issuer Code</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.issuerCode || "---"}</p>
                                                </dd>
                                            </dl>

                                            <h5 className="font-weight-bold">Card configuration details</h5>
                                            <hr className="my-3" />
                                            <dl className="row">
                                                <dt className="col-sm-5">Card Scheme</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.cardScheme || "---"}</p>
                                                </dd>

                                                {/* <dt className="col-sm-5">Card Type</dt>
                        <dd className="col-sm-7">
                          <p>{configObj.cardProgram || "---"}</p>
                        </dd> */}

                                                <dt className="col-sm-5">Card Program</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.cardProgram || "---"}</p>
                                                </dd>

                                                {/* <dt className="col-sm-5">SCP Card Program</dt>
                        <dd className="col-sm-7">
                          <p>{configObj.scpCardProgram || "---"}</p>
                        </dd> */}
                                            </dl>

                                            <h5 className="font-weight-bold">Card/EMV profile details</h5>
                                            <hr className="my-3" />
                                            <dl className="row">
                                                <dt className="col-sm-5">Card Profile Code</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.cardProfileCode || "---"}</p>
                                                </dd>

                                                <dt className="col-sm-5">EMV Profile Code</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.emvProfileCode || "---"}</p>
                                                </dd>
                                            </dl>
                                        </Col>
                                        <Col sm="6">
                                            <h5 className="font-weight-bold">Perso details</h5>
                                            <hr className="my-3" />
                                            <dl className="row">
                                                <dt className="col-sm-5">Perso Code</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.persoCode || "---"}</p>
                                                </dd>

                                                <dt className="col-sm-5">Perso Format Code</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.persoFormatCode || "---"}</p>
                                                </dd>

                                                <dt className="col-sm-5">Auto upload to Perso</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.autoUploadPerso ? "Yes" : "No"}</p>
                                                </dd>
                                            </dl>

                                            <h5 className="font-weight-bold">PIN Configuration details</h5>
                                            <hr className="my-3" />
                                            <dl className="row">
                                                <dt className="col-sm-5">Default Pin Value</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.defaultPinValue || "---"}</p>
                                                </dd>

                                                <dt className="col-sm-5">Pin Generation Method</dt>
                                                <dd className="col-sm-7">
                                                    <p>{configObj.pinGenerationMethod || "---"}</p>
                                                </dd>
                                            </dl>
                                            {/* <h5 className="font-weight-bold">
                    Batch Configuration details
                  </h5>
                  <hr className="my-3" />
                  <dl className="row">
                    <dt className="col-sm-2">Batch ID</dt>
                    <dd className="col-sm-10">
                      <p>{configObj.batchId || "---"}</p>
                    </dd>
                  </dl>
                  <h5 className="font-weight-bold">
                    Batch Configuration records
                  </h5>
                  <hr className="my-3" />
                  <Row>
                    <Col sm="12">
                      <BatchRecordsTable
                        data={configObj.batchIssuanceRecords || []}
                      />
                    </Col>
                  </Row>*/}
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        ) : (
                            <div className="text-center">
                                {config && config.loading ? (
                                    <div>
                                        <Spinner color="success" className="my-4" style={{ width: "6rem", height: "6rem" }} />
                                        <h4 className="text-secondary">Fetching config with name: ({configId})</h4>
                                    </div>
                                ) : (
                                    <div>
                                        <h4 className="text-danger">{config.error ? `Something went wrong. Could not fetch config with name (${configId})` : `Config with name (${configId}) not found`}</h4>
                                        <Button color="primary" outline id="btn-fetch-config" size="sm" onClick={fetchData}>
                                            Try Again
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                        {config && !config.loading && !viewOnly ? (
                            <h5 className="bold-text mt-4">
                                <Link to="/issuers/config" id="link-all-configs">
                                    <MdArrowBack size={20} /> Back to configurations
                                </Link>
                            </h5>
                        ) : null}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default ConfigView;
